import React, { useState } from "react";
import "../css/getPayAccount.scss";

const GetPayAccount = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);

  // 处理申请按钮点击
  const handleApplyClick = (account, index) => {
    setSelectedAccount({ ...account, index });
    setShowModal(true);
  };

  // 关闭模态框
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedAccount(null);
  };

  // 账户类型数据
  const accountTypes = [
    {
      icon: "/account/a1-1.png",
      title: "电商收款账户",
      description:
        "为主流跨境和本土电商平台、独立站、自建站等跨境卖家提供收款服务",
      features: [
        "收款能广覆盖北美区、欧元区、英国、澳大利亚、日本、印度、新加坡、香港、马来西亚、菲律宾、越南、泰国、韩国、加拿大、中东等区域。",
      ],
      platforms: "/account/a2-1.png",
      buttonText: "立即申请",
    },
    {
      icon: "/account/a1-2.png",
      title: "服贸收款账户",
      description:
        "依托GEP强大的多币种跨境和本土账户体系收款全球本地风险区域拓展广告、物流、软件服务等特色均衡的款项。",
      features: [],
      platforms: "/account/a2-2.png",
      buttonText: "立即申请",
    },
    {
      icon: "/account/a1-3.png",
      title: "E贸汇收款账户",
      description: "为中小外贸企业，提供一站式收款解决方案",
      features: [
        "一站式全球多币种跨境收款，最快当日到账",
        "提供专业的外贸产品和极具优势的汇率",
      ],
      platforms: "/account/a3-3.png",
      buttonText: "立即申请",
    },
    {
      icon: "/account/a1-4.png",
      title: "其他收款账户",
      description: "货币兑换",
      features: [
        "海外分发",
        "VCC（虚拟信用卡）",
        "...",
        "若您需要使用以上功能请仔细阅读账户",
      ],
      platforms: "/account/a3-4.png",
      buttonText: "立即申请",
    },
  ];

  return (
    <>
      <div className="get-pay-account">
        <div className="page-header">
          <h1>全球收款账户</h1>
        </div>

        <div className="account-cards">
          {accountTypes.map((account, index) => (
            <div key={index} className="account-card">
              <div className="card-header">
                <div className="card-icon">
                  <img src={account.icon} alt={account.title} />
                </div>
                <h2>{account.title}</h2>
                <button
                  className={`apply-btn ${
                    index === 1 || index === 3 ? "apply-btn-blue" : ""
                  }`}
                  onClick={() => handleApplyClick(account, index)}
                >
                  {account.buttonText}
                </button>
              </div>

              <div className="card-content">
                <p className="description">{account.description}</p>

                {account.features.length > 0 && (
                  <ul className="features">
                    {account.features.map((feature, idx) => (
                      <li key={idx}>{feature}</li>
                    ))}
                  </ul>
                )}

                <div
                  className={`platforms ${
                    account.title === "其他收款账户" ? "platforms-two-col" : ""
                  }`}
                >
                  <img alt="" src={account.platforms} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <footer className="page-footer">
        <p>© 2022 GLOBAL E-PAYMENT LIMITED. All Rights Reserved.</p>
      </footer>

      {/* 未授权访问提示 */}
      {showModal && selectedAccount && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-icon">🔒</div>
            <h2 className="modal-title">未授权访问</h2>
            <p className="modal-message">您当前没有权限访问此功能</p>
          </div>
        </div>
      )}
    </>
  );
};

export default GetPayAccount;
